<div class="ols-fake-section">
  <app-fake-content-item *ngIf="showTitle" [isTitle]="true"></app-fake-content-item>

  @for (item of [].constructor(rowCount); track item; let  i = $index) {
    <app-fake-content-item [isTekstLong]="i % 2 == 0"></app-fake-content-item>
  }
</div>